import React, { PureComponent } from 'react';
import { Button } from 'react-bootstrap';

import ModalResult from '../../facturotopia/ModalResult';

class ResponseError extends PureComponent {

  handleOnAction = () => {
    this.props.onAction('reset');
  }

  getInnerError = () => {

  }

  render() {
    const { title, error, status = 'error', btnText = 'Ok', variant = 'modal' } = this.props;

    return (
      <>
        { variant === 'modal' && (
          <ModalResult status={ status }
            title={ title || 'Error' }
            subtitle={ error.message }
            extra={
              <Button type="button"
                onClick={ this.handleOnAction }>
                { btnText }
              </Button>
            }
          >
            { !!error.errors && error.errors.length > 0 && (
                <div>
                  <strong>
                    Revise los siguientes errores: <br />
                  </strong>
                  <ul>
                    { error.errors.map((item, index) => <li key={ index }>{ item.message }</li>) }
                  </ul>
                </div>
              )
            }
          </ModalResult>
        )}

        { variant !== 'modal' && (
          <>
            <div className="result py-2">
              <div className="text-danger">
                { error.message }
              </div>

              { !!error.errors && error.errors.length > 0 && (
                  <div className="result-content">
                    <strong>
                      Revise los siguientes errores: <br />
                    </strong>
                    <ul>
                      { error.errors.map((item, index) => <li key={ index }>{ item.message }</li>) }
                    </ul>
                  </div>
                )
              }
            </div>
          </>
        )}
      </>

    )
  }

}

export default ResponseError;